import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import useOrder from 'Core/hooks/queries/order/useOrder';
import useAlertStore, { setErrorAlertSelector } from 'Core/stores/alert';
import cacheKeys from 'Core/hooks/queries/cacheKeys';
import { get } from 'Core/utils/api';

export const queryFn = (orderId) => get(`/api/orders/${orderId}/payment-summary`);

export default function useGetPaymentSummary() {
  const { data: order } = useOrder();
  const { t } = useTranslation();
  const setErrorAlert = useAlertStore(setErrorAlertSelector);

  return useQuery(cacheKeys.paymentSummary, () => queryFn(order.orderId), {
    enabled: Boolean(order),
    onError(e) {
      setErrorAlert(t('status.error.paymentSummaryQueryFailed'));
      throw e;
    },
  });
}
